import {useAuthInfo} from "@propelauth/react";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";
import React, {useContext, useEffect} from "react";

import {VEListItem, VEPricing, VESuggestion} from "./ve_model";
import {useParams} from "react-router-dom";
import {UserContext} from "../../contexts/UserContext";
import {Controller, FormProvider, SubmitHandler, useForm, useFormContext} from 'react-hook-form';
import {deleteWithToken, fetchWithToken, postWithToken, putWithToken} from "../../api/apiBase";
import {CompanyType} from "../../models/company";
import {AutosizeTextarea} from "../ui/autoresizeTextArea";
import {Input} from "../ui/input";
import {Button} from "../ui/button";
import {FormControl, FormItem, FormLabel} from "../ui/form";
import {Separator} from "../ui/separator"
import {useToast} from "../ui/use-toast";
import {moneyFormatter, onChangeMoneyField} from "../../lib/formatters";


function errorToast(error: any) {
    return {
        title: "Error",
        description: JSON.stringify(error) || "Could not update price",
        variant: "destructive",
    }
}


function validVEListItem(something: any) {
    if (!something) {
        return {
            suggestion: defaultSuggestion(),
            price: defaultPrice()
        }
    } else if (!something.price) {

    }
}


interface SubFormProps {
    disabled: boolean;
    hidden: boolean;
    entity: VEListItem | null;
}

type VEItemProps = {
    price_id: string | null;
    suggestion_id: string | null;
    setItemId: (x: string) => void;
    setSuggestionId: (x: string) => void;
    updateItem: (item: VEListItem) => void;
    insertItem: (item: VEListItem) => void;
    hideItem: (item: VEListItem) => void;
    suggestionPrice: VEListItem | null;
};


function defaultSuggestion() {
    return {
        created_by: {
            name: '',
            email: '',
        },
        description: " ",
        title: " ",
        shared_state: {
            share_requested: false,
            share_enabled: false,
        }
    }
}

function defaultPrice() {
    return {
        savings_amount: 0,
        description: " ",
    }
}


const SuggestionForm = ({disabled, hidden, entity}: SubFormProps) => {
    const {control} = useFormContext();
    const userContext = useContext(UserContext);
    if (hidden) {
        return <></>
    }
    return <>
        <Controller
            name={`suggestion.title`}
            control={control}
            disabled={disabled}
            render={({field}) =>
                <FormItem>
                    <FormLabel>Title</FormLabel>
                    <FormControl>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            :
                            <Input className="w-full"
                                   data-test-id="suggestion.title"
                                   {...field}
                                   value={field.value? field.value : "" }
                                   onChange={field.onChange}
                                   placeholder="Title"/>}
                    </FormControl>
                </FormItem>}
        />
        <Controller
            name={`suggestion.description`}
            control={control}
            disabled={disabled}
            render={({field}) =>
                <FormItem>
                    <FormLabel>Description</FormLabel>
                    <FormControl>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            :
                            <AutosizeTextarea className="w-full" {...field} placeholder="Description"/>}
                    </FormControl>
                </FormItem>}
        />
        <div className="mt-2 text-xs"><span>Suggested by : </span><span>{
            // if we the suggestion was created by someone in our comapny, show the name,
            // otherwise it iwll not be available
            (entity?.suggestion?.created_by?.name &&
                entity?.suggestion?.created_by?.company.id === userContext?.company_id)
                || userContext?.company_type === CompanyType.developer
                ? <>
                    <span>{entity?.suggestion?.created_by?.email}</span>
                    <span> - </span>
                    <span>{entity?.suggestion?.created_by?.company.name}</span>
                </>
                : "by others"
        }</span></div>
    </>
};

const PriceForm = ({disabled, hidden}: SubFormProps) => {
    const {control} = useFormContext();
    if (hidden) {
        return <></>
    }
    return (
        <>
            <Controller
                name="price.title"
                control={control}
                disabled={disabled}
                render={({field}) =>
                    <FormItem>
                        <FormLabel>Title</FormLabel>
                        <FormControl>
                            {disabled ? (
                                    <div className="mt-2">
                                        <span>{field.value || "N/A"}</span>
                                    </div>)
                                :
                                <Input className="w-full" {...field}
                                       value={field.value? field.value : "" }
                                        onChange={field.onChange}
                                       placeholder="Title"/>}
                        </FormControl>
                    </FormItem>

                }
            />
            <Controller
                name="price.savings_amount"
                control={control}
                disabled={disabled}
                render={({field}) =>
                    <FormItem>
                        <FormLabel>Savings Amount *</FormLabel>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            :
                            <Input
                                {...field}
                                className="w-full"
                                placeholder="Savings Amount"
                                value={field.value ? moneyFormatter.format(Number(field.value)) : ""}
                                required={true}
                                onChange={(e) => onChangeMoneyField(field, e)}
                            />
                        }
                    </FormItem>
                }
            />

            <Controller
                name="price.description"
                control={control}
                disabled={disabled}
                render={({field}) =>
                    <FormItem>
                        <FormLabel>Notes</FormLabel>
                        {disabled ? (
                                <div className="mt-2">
                                    <span>{field.value || "N/A"}</span>
                                </div>)
                            : <AutosizeTextarea {...field}
                                                value={field.value? field.value : "" }
                                                onChange={field.onChange}
                                                placeholder="Description"/>}
                    </FormItem>

                }
            />
        </>
    );
};


/**
 * There are really two cases here.
 *  - with subcases by party
 * Developer
 *  - create    [null, null] ->      [sug]
 *  - view/edit [null, null] ->      [sug]
 *  - edit      [not null, null ] -> [ sug ] -> [sug]
 *
 * Bidder
 *  - create [null, null] ->         [sug+price]
 *  - edit   [not null, not null] -> [ price ]
 *  - price  [not null, null ] -> [ price ]
 *
 * blah blah blah --- certain aspects of the code tell me i dont have the right concept here....
 *  --- that and it doesnt support a nice (or even mildly reasonable) way to integrate vendors which **** is selling
 *
 * The more general concept is....
 *   we have a suggestion "X" to make the project better.
 *   we have a chain of parties:
 *   [a] - [b] - [c]
 *
 *   [a] - typically developer
 *   [b] - typically cm
 *   [c] - typically sub
 *   ... but doesnt matter - as long as:
 *
 *      a suggestion 'on-the-chain' can originate anywhere
 *      some parts of the chain have higher trust over some properties of the artifact.
 *      in other words - everyone can predict a price --- just some have higher weight in reality.
 *      (market-expertise-wighted-price?)
 *
 *   chains have direction.
 *      [up the chain]   => more power/approval capability AND less domain specific knowledge
 *      [down the chain] => (opposite of up the chain - lol)
 *
 *   when something is created in the chain ---
 *      the point is to test it up and down the chain.
 *      up for market fit.
 *      down for pricing and scale.
 *
 *    - is 'assigning confidence' to a concept a valid method of feedback?
 *
 *    - blockchain/some smart-contract stuff if maybe relevant...

 *    - more-so the concept of signal modulators ... if i can remember the thing i am thinking of here...
 *
 * Back to markets:
 *   given a "suggestion" X.
 *   in theory, a developer (a) has perfect knowledge if all members of {C} have given their input on X.
 *
 *   let {c_b_i} be the subset of {C} that builder "b_i" has input from.
 *   lets say there is some overlap in {c_b_i}, {c_b_j} ....
 *
 *   at some point subcontractor c_i will have seen the same suggestion several times from various builders.
 *
 * */
function VeItemForm({updateItem, insertItem, hideItem, suggestion_id, price_id, suggestionPrice}: VEItemProps) {
    const {project_id} = useParams<{ project_id: string }>();
    const {accessToken} = useAuthInfo();
    const {toast} = useToast();
    const userContext = React.useContext(UserContext);
    const isBuilder = userContext?.company_type === CompanyType.builder;
    const isDeveloper = userContext?.company_type === CompanyType.developer;
    const [isDisabled, setIsDisabled] = React.useState<boolean>(false);

    const methods = useForm<VEListItem>();

    useEffect(() => {
        const fetchFormData = async () => {
            fetchWithToken(
                `/projects/${project_id}/ve/${suggestion_id}`,
                accessToken as string)
                .then((response) => {
                    methods.reset({
                        suggestion: {...response.suggestion},
                        price: response.prices.length > 0 ? response.prices[0] : defaultPrice()
                    })
                }).catch((err) => {
                toast({variant: "destructive", title: "Error", description: err || "Failed to laod",});
            });
        };

        methods.reset({
            suggestion: defaultSuggestion(),
            price: defaultPrice()
        })
        if (suggestionPrice) {
            methods.reset(suggestionPrice)

        } else if (accessToken && suggestion_id) {
            fetchFormData();
        }
    }, [suggestion_id, price_id]);

    const onCreateSuggestion = async (data: VEListItem) => {
        // DEVELOPER or BUILDER ,
        // both map to same endpoint...
        // todo - im honestly not sure where to solve for this
        setIsDisabled(true)
        let transformed = null;
        if (userContext?.company_type === CompanyType.builder) {
            // Builder: create a full suggestion (with price)
            // in the chain concept -> this woulde be 'propogate up'
            transformed = {...data.price, price: data.price}

        } else {
            // Developer: create a suggestion without price
            // in the chain concept -> this woulde be 'propogate down'
            transformed = {...data.suggestion}
        }
        console.log('creating as : ', userContext?.company_type, transformed)

        postWithToken(
            `/projects/${project_id}/ve/create`,
            JSON.stringify(transformed),
            accessToken as string)
            .then((response: VEListItem) => {
                methods.reset(response);
                insertItem(response);
                
                toast({title: "Success!", description: "Suggestion Submitted.", variant: "default"});
            }).catch((err) => {
            toast({variant: "destructive", title: "Error", description: JSON.stringify(err) || "Could not Create Suggesition",});
        }).finally(()=> setIsDisabled(false))
    };

    const onUpdateSuggestion = async (data: VEListItem) => {
        // DEVELOPER ONLY
        setIsDisabled(true)
        putWithToken(
            `/projects/${project_id}/ve/${suggestion_id}/suggestion`,
            JSON.stringify(data.suggestion),
            accessToken as string)
            .then((response: VESuggestion) => {
                methods.reset({suggestion: response, price: data.price});
                updateItem({suggestion: response, price: data.price});
                toast({title: "Success!", description: "Suggestion updated.", variant: "default"});
            })
            .catch((err) => {
                toast({variant: "destructive", title: "Error", description: err || "Could not update Suggestion",});
            }).finally(()=> setIsDisabled(false));;
    };

    const onCreatePrice = async (data: VEListItem) => {
        if (userContext?.company_type === CompanyType.developer) {
            console.warn('error - this should not happen !!!')
            return
        } else if (!(accessToken && suggestion_id)) {
            console.warn('WARNING - this should not happen !!!');
            return
        }
        setIsDisabled(true)
        postWithToken(
            `/projects/${project_id}/ve/${suggestion_id}/price`,
            JSON.stringify(data.price),
            accessToken)
            .then((response: VEPricing) => {
                // todo -> response caintains a 'feedback' element...
                methods.reset({suggestion: data.suggestion, price:response});
                updateItem({suggestion: data.suggestion, price:response});
                toast({title: "Success!", description: "Price Submitted.", variant: "default"});

            })
            .catch((err => {
                toast({variant: "destructive", title: "Error", description: err || "Could not Create price",});
            })).finally(()=> setIsDisabled(false));
    };

    const onUpdatePrice = async (data: VEListItem) => {
        // BUILDER : updating a price. Suggestion exists
        if (userContext?.company_type === CompanyType.developer) {
            console.warn('WARNING - this should not happen !!!');
            return
        } else if (!(accessToken && suggestion_id && price_id)) {
            console.warn('WARNING - this should not happen !!!', accessToken && suggestion_id && price_id);
            return
        }
        setIsDisabled(true)
        updateItem({
            suggestion: suggestionPrice ? suggestionPrice.suggestion : data.suggestion,
            price: data.price
        });
        console.log('udpate price', data)
        putWithToken(
            `/projects/${project_id}/ve/${suggestion_id}/price/${price_id}`,
            JSON.stringify(data.price),
            accessToken as string)
            .then((response: VEPricing) => {

                methods.reset({
                    suggestion: suggestionPrice ? suggestionPrice.suggestion : data.suggestion,
                    price: response
                });
                toast({title: "Success!", description: "Price updated.", variant: "default"});

            })
            .catch((err => {
                toast({variant: "destructive", title: "Error", description: err || "Could not update price",});
            })).finally(()=> setIsDisabled(false));;
    };

    const onDeletePrice = async (data: VEListItem) => {
        // TODO BUILDER ONLY:
        if (userContext?.company_type === CompanyType.developer) {
            console.warn('WARNING - this should not happen !!!');
            return
        } else if (!(accessToken && suggestion_id && price_id)) {
            console.warn('WARNING - this should not happen !!!', accessToken && suggestion_id && price_id);
            return
        }
        deleteWithToken(
            `/projects/${project_id}/ve/${suggestion_id}/price/${price_id}`,
            accessToken as string)
            .then((response: boolean) => {
                hideItem(data)

            })
            .catch((err => {
                toast({variant: "destructive", title: "Error", description: err || "Could not update price",});
            }));
    };

    const onSubmit: SubmitHandler<VEListItem> = (data) => {
        if (!suggestion_id) {
            onCreateSuggestion(data);

        } else if (suggestion_id && !price_id) {

            if (userContext?.company_type == CompanyType.builder) {
                onCreatePrice(data);
            } else {
                onUpdateSuggestion(data);
            }

        } else {
            if (userContext?.company_type == CompanyType.builder) {
                onUpdatePrice(data);
            } else {
                onUpdateSuggestion(data);
            }
        }
    };

    return (
        <Card>
            <CardHeader> <CardTitle>VE Suggestion </CardTitle> </CardHeader>
            <CardContent>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                        {/* show original suggestion */}
                        <SuggestionForm
                            entity={suggestionPrice}
                            disabled={isBuilder}
                            hidden={isBuilder && suggestion_id === null}
                        />

                        <Separator className="m-3"/>
                        {/*<CardTitle>Pricing:</CardTitle>*/}
                        <PriceForm
                            entity={suggestionPrice}
                            disabled={isDeveloper}
                            hidden={isDeveloper && suggestion_id === null}
                        />
                        <br/>
                        <Button type="submit" disabled={isDisabled}>Save</Button>
                    </form>
                </FormProvider>
            </CardContent>
        </Card>
    )
}


export default VeItemForm;